module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "profitCenterTesting.3683948c.png";